module.exports = __webpack_public_path__ + "8269463fb6ac153c1e8b305f1d591c18.svg";